<template>
  <div id="app">
    <vue-extend-layouts />
    <Alert/>
    <Loading/>
  </div>
</template>

<script>
import VueExtendLayouts from 'vue-extend-layout';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'App',
  components: {
    VueExtendLayouts,
    Alert,
    Loading,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

$image-path: '~@/../mdb/mdbvue/img';
@import '~@/../mdb/mdbvue/scss/mdb-free.scss';

</style>
